<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>New Version of {{ utils.getLangTerm('ta-jsa-swms.singular', 'TA/JSA/SWMS') }} - {{ taskName }}</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<form #form="ngForm">

  <hr class="m-0 p-0">

  <mat-dialog-content class="py-4">

    <mat-form-field class="mb-4" appearance="outline" subscriptSizing="dynamic">
      <mat-label>Amendment Title</mat-label>
      <input
        matInput
        placeholder="Amendment Title"
        [(ngModel)]="amendmentTitle"
        name="amendment_title"
        type="text"
        required
        #amendment_title />
      <mat-hint>Please enter an Amendment title.</mat-hint>
    </mat-form-field>

    <mat-form-field class="mb-4" appearance="outline" subscriptSizing="dynamic">
      <mat-label>Reason for Amendment</mat-label>
      <textarea
        rows="4"
        matInput
        placeholder="Reason for Amendment"
        [(ngModel)]="reasonForAmendment"
        name="reason_for_amendment"
        required
        #reason_for_amendment>
      </textarea>
      <mat-hint>Please enter a Reason for Amendment.</mat-hint>
    </mat-form-field>

    <div class="row">
      <div class="col-12 mt-0">
        <div class="alert alert-warning mb-0" role="alert">
          You are about to create a new version of the current {{ utils.getLangTerm('ta-jsa-swms.singular', 'TA/JSA/SWMS') }}. <br>Please enter an amendment title and a reason for amendment before continuing. The new version will need to be acknowledged by everyone who is associated with it.
        </div>
      </div>
    </div>

  </mat-dialog-content>

  <hr class="m-0 p-0">

  <mat-dialog-actions class="d-flex flex-wrap justify-content-center my-2 py-2">
    <ng-container matColumnDef="buttons">
      <div class="p-2">
        <button
          mat-raised-button
          type="button"
          id="cancel"
          (click)="onCancel()">
          <mat-icon>cancel</mat-icon>
          Cancel
        </button>
      </div>

      <div class="p-2">
        <button
          mat-raised-button
          [disabled]="!form.valid"
          color="primary"
          type="button"
          id="continue"
          (click)="onContinue(form)">
          <mat-icon>arrow_forward</mat-icon>
          Continue
        </button>
      </div>
    </ng-container>
  </mat-dialog-actions>

</form>
